import {ValueOf} from "../util/UtilTypes";

export const CourseLevel = {
	ELEMENTARY: "Elementary School",
	MIDDLE_AND_HIGH: "Middle and High School",
	UNDEFINED: "undefined", // For catalog sections without a defined course level
} as const;

export type CourseLevel = ValueOf<typeof CourseLevel>;

export interface StrapiCourseLevel {
	data: {
		attributes: {
			name: CourseLevel;
		};
	};
}
